<form
    *ngIf="{
        orders: (orders$ | async),
        ordersPageNum: (ordersPageNum$ | async)!,
        variations: (variations$ | async),
        variationsPageNum: (variationsPageNum$ | async)!,
    } as data">
    <header class="modal-header">
        <h4 class="modal-title">Select an Order {{ this.hasCompactJobs ? '' : ('or ' + 'general.variation' | translate) }}</h4>
    </header>
    <div class="modal-body side-panel-body">
        <div class="search-box-bx new">
            <span class="input-icon input-icon-left">
                <input
                    type="text"
                    aria-label="search"
                    [(ngModel)]="search"
                    name="search"
                    (ngModelChange)="searchText$.next(search)"
                    placeholder="Search for a number or a description"
                    class="form-control-v2 search add-to-existing-aside-search" />
                <i class="icon-ic-search-s1"></i>
            </span>
        </div>

        <p>Select an Order {{ this.hasCompactJobs ? '' : ('or ' + 'general.variation' | translate) }} from below.</p>

        <!-- Orders -->
        @if (canCreateOrders) {
            <div class="margin-bottom-10">
                <h4>Orders</h4>
                <div *ngIf="data.orders && !data.orders.length">No orders found.</div>
                <app-bx-spinner *ngIf="!data.orders"></app-bx-spinner>
            </div>
            @if (data.orders) {
                <div class="table-wrapper" #tableWrapper>
                    <ngx-datatable
                        #ordersTable
                        class="material bxt-table"
                        [rowHeight]="40"
                        [rows]="data.orders"
                        columnMode="force"
                        [headerHeight]="50"
                        [loadingIndicator]="isLoading"
                        [footerHeight]="50"
                        [externalPaging]="true"
                        [count]="totalOrders"
                        [offset]="data.ordersPageNum"
                        [limit]="pageSize"
                        (page)="ordersPageNum$.next($event.offset)"
                        [virtualization]="false"
                        *ngIf="data.orders.length">
                        <!-- columns  -->
                        <ngx-datatable-column
                            name="Order #"
                            prop="orderNumber"
                            [headerClass]="'show-pipe'"
                            [cellClass]="'show-pipe'"
                            [flexGrow]="4"
                            [resizeable]="false"
                            [draggable]="false"
                            [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>{{ row.orderNumber }}</ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                            name="Contact"
                            prop="supplierDescription"
                            [flexGrow]="6"
                            [resizeable]="false"
                            [draggable]="false"
                            [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span [title]="row.supplierDescription">{{ row.supplierDescription }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                            name="Description"
                            prop="description"
                            [flexGrow]="6"
                            [resizeable]="false"
                            [draggable]="false"
                            [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span [title]="row.description">{{ row.description }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                            name="Date created"
                            prop="orderDate"
                            [flexGrow]="5"
                            [resizeable]="false"
                            [draggable]="false"
                            [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.orderDate | date }}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                            name="Total (Ex)"
                            prop="orderTotalExTax"
                            [flexGrow]="5"
                            [cellClass]="'right-align'"
                            [resizeable]="false"
                            [draggable]="false"
                            [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span [title]="row.orderTotalExTax | bxCurrency">{{ row.orderTotalExTax | bxCurrency }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Type" [resizeable]="false" [draggable]="false" [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.orderType === 'purchase' ? 'PO' : 'WO' }}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [resizeable]="false" [draggable]="false" [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <button class="btn-bx-hyperlink" (click)="selectOrder(row)">Select</button>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-footer>
                            <ng-template
                                ngx-datatable-footer-template
                                let-rowCount="rowCount"
                                let-pageSize="pageSize"
                                let-selectedCount="selectedCount"
                                let-curPage="curPage"
                                let-offset="offset"
                                let-isVisible="isVisible">
                                <datatable-pager
                                    [pagerLeftArrowIcon]="'datatable-icon-left'"
                                    [pagerRightArrowIcon]="'datatable-icon-right'"
                                    [pagerPreviousIcon]="'datatable-icon-prev'"
                                    [pagerNextIcon]="'datatable-icon-skip'"
                                    [page]="curPage"
                                    [size]="pageSize"
                                    [count]="rowCount"
                                    [hidden]="!(rowCount / pageSize > 1)"
                                    (change)="ordersTable.onFooterPage($event)">
                                </datatable-pager>
                            </ng-template>
                        </ngx-datatable-footer>
                    </ngx-datatable>
                </div>
            }
        }

        <!-- Variations -->
        @if (canCreateVariations) {
            <div class="margin-bottom-10">
                <h4>{{ 'general.variations' | translate }}</h4>
                <div *ngIf="data.variations && !data.variations.length">No {{ 'general.variations' | translate | lowercase }} found.</div>
                <app-bx-spinner *ngIf="!data.variations"></app-bx-spinner>
            </div>
            @if (data.variations) {
                <div class="table-wrapper" #tableWrapper>
                    <ngx-datatable
                        #variationsTable
                        class="material bxt-table"
                        [rowHeight]="40"
                        [rows]="data.variations"
                        columnMode="force"
                        [headerHeight]="50"
                        [loadingIndicator]="isLoading"
                        [footerHeight]="50"
                        [externalPaging]="true"
                        [count]="totalVariations"
                        [offset]="data.variationsPageNum"
                        [limit]="pageSize"
                        (page)="variationsPageNum$.next($event.offset)"
                        [virtualization]="false"
                        *ngIf="data.variations.length">
                        <!-- columns  -->
                        <ngx-datatable-column
                            name="{{ 'general.variation' | translate }} #"
                            prop="variationNumber"
                            [headerClass]="'show-pipe'"
                            [cellClass]="'show-pipe'"
                            [flexGrow]="4"
                            [resizeable]="false"
                            [draggable]="false"
                            [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>{{ row.variationNo }}</ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                            name="Description"
                            prop="description"
                            [flexGrow]="6"
                            [resizeable]="false"
                            [draggable]="false"
                            [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span [title]="row.description">{{ row.description }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                            name="Date created"
                            prop="createdAt"
                            [flexGrow]="5"
                            [resizeable]="false"
                            [draggable]="false"
                            [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ row.createdAt | date }}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column
                            name="Total"
                            prop="totalIncTax"
                            [flexGrow]="5"
                            [cellClass]="'right-align'"
                            [resizeable]="false"
                            [draggable]="false"
                            [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <span [title]="row.totalIncTax | bxCurrency">{{ row.totalIncTax | bxCurrency }}</span>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Type" [resizeable]="false" [draggable]="false" [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                {{ (row.isAdjustment ? 'general.adjustment' : 'general.variation') | translate }}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column [resizeable]="false" [draggable]="false" [sortable]="false">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <button class="btn-bx-hyperlink" (click)="selectVariation(row)">Select</button>
                            </ng-template>
                        </ngx-datatable-column>

                        <ngx-datatable-footer>
                            <ng-template
                                ngx-datatable-footer-template
                                let-rowCount="rowCount"
                                let-pageSize="pageSize"
                                let-selectedCount="selectedCount"
                                let-curPage="curPage"
                                let-offset="offset"
                                let-isVisible="isVisible">
                                <datatable-pager
                                    [pagerLeftArrowIcon]="'datatable-icon-left'"
                                    [pagerRightArrowIcon]="'datatable-icon-right'"
                                    [pagerPreviousIcon]="'datatable-icon-prev'"
                                    [pagerNextIcon]="'datatable-icon-skip'"
                                    [page]="curPage"
                                    [size]="pageSize"
                                    [count]="rowCount"
                                    [hidden]="!(rowCount / pageSize > 1)"
                                    (change)="variationsTable.onFooterPage($event)">
                                </datatable-pager>
                            </ng-template>
                        </ngx-datatable-footer>
                    </ngx-datatable>
                </div>
            }
        }
    </div>
    <footer class="modal-footer">
        <button type="button" class="btn-bx-secondary-stroked" (click)="cancel()">Cancel</button>
    </footer>
</form>
